
import { StorageError } from './errors';

const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

export function sanitizeFileName(fileName: string): string {
  return fileName
    .toLowerCase()
    .replace(/[^a-z0-9.]/g, '-')
    .replace(/-+/g, '-');
}

export function validateImageFile(file: File) {
  if (!file) {
    throw new StorageError('No file provided', 'VALIDATION_ERROR');
  }

  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    throw new StorageError(
      'Please upload a valid image file (JPEG, PNG, WebP, or GIF)',
      'INVALID_FILE_TYPE',
      { type: file.type, name: file.name }
    );
  }

  if (file.size > MAX_FILE_SIZE) {
    throw new StorageError(
      'Image file size must be less than 5MB',
      'FILE_TOO_LARGE',
      { size: file.size, maxSize: MAX_FILE_SIZE }
    );
  }
}

export function validateImageUrl(url: string) {
  if (!url || !url.trim()) {
    throw new StorageError('Please provide a valid image URL', 'VALIDATION_ERROR');
  }

  try {
    new URL(url);
  } catch {
    throw new StorageError('Invalid URL format', 'INVALID_URL');
  }
}
